module.exports = __webpack_public_path__ + "img/hi_in.18606484.svg";